import { render, staticRenderFns } from "./inspect-time-data.vue?vue&type=template&id=2c85ca78&scoped=true"
import script from "./inspect-time-data.vue?vue&type=script&lang=js"
export * from "./inspect-time-data.vue?vue&type=script&lang=js"
import style0 from "./inspect-time-data.vue?vue&type=style&index=0&id=2c85ca78&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c85ca78",
  null
  
)

export default component.exports